import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { atLeastOneDaySelectedValidator } from '../../employees/add-employees/add-employees.component';
import { ApiService } from 'src/app/services/api.service';
import { Helps } from 'src/app/libs/helps';
import { SmsUtils } from 'src/app/modules/common/sms/sms-utils';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.css']
})
export class AddUsersComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal,
    private apiFull:ApiService,
    private helps:Helps
  ) { }

  ngOnInit(): void {
    this.getState();
    this.level = this.helps?.getToken()?.level;
    if (this.storesId > 0) {
      this.form1.get('stores_id')?.setValue(this.storesId);
    }
  }
  items:any;
  @Output()
  success = new EventEmitter<boolean>();

  @Input()
  storesId: number;
  notSendVisSms = true;
  notSendVisEmail = true;
  notSendProvSms = true;
  notSendProvEmail = true;
  level: number = 0;

  form1: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    email: [''],
    phone: [''],
    pass:[''],
    state_id:[0],
    stores_id: [0],
    send_not_vis_sms: [0],
    send_not_vis_email: [0],
    send_not_prov_sms: [0],
    send_not_prov_email: [0]
  });

  create() {
    const selectedDays = this.form1.value.xdays as string[];
    const daysString = selectedDays ? selectedDays.join(',') : '';

    this.form1?.get('days')?.setValue(daysString);

    this.api.createUsers(this.form1).subscribe(
      (res) => {
        this.toast.success(res.msg, 'Registro Administrador');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }
  getState(){
    this.apiFull.getState().subscribe((res)=>{
      this.items=res.data;
    });
  }


  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1.get('rut')?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  activeSendVisSms(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_vis_sms')?.setValue(value);
  }
  activeSendProvSms(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_prov_sms')?.setValue(value);
  }
  activeSendVisEmail(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_vis_email')?.setValue(value);
  }
  activeSendProvEmail(event: any) {
    let checked: boolean = event?.target.checked;
    let value = (checked) ? 1 : 0;
    this.form1.get('send_not_prov_email')?.setValue(value);
  }
  checkPhoneNumber(type:number=1) {
    if (SmsUtils.isNumberPhone(this.form1.get('phone')?.value)) {
      console.log("Valido:", this.form1.get('phone')?.value);
        this.notSendVisSms = false;
        this.notSendProvSms = false;

    } else {
      console.log("No valido:", this.form1.get('phone')?.value);
        this.notSendVisSms = true;
        this.form1.get('send_not_vis_sms')?.setValue(0);
        this.notSendProvSms = true;
        this.form1.get('send_not_prov_sms')?.setValue(0);
    }
  }
  checkEmail(type:number=1) {
    if (Helps.isValidEmail(this.form1.get('email')?.value)) {
      console.log("Valido:", this.form1.get('email')?.value);
        this.notSendVisEmail = false;
        this.notSendProvEmail = false;
    } else {
        this.notSendVisEmail= true;
        this.form1.get('send_not_vis_email')?.setValue(0);
        this.notSendProvEmail= true;
        this.form1.get('send_not_prov_email')?.setValue(0);
    }
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
